const D2DIAGRAM_DEFAULT_THEME_OVERRIDES: Record<string, string> = {
  N1: '#0A082F',
  N2: '#6C6B82',
  N4: '#CECED5',
  N5: '#E2E1E6',
  N7: '#FFFFFF',
  B1: '#B9BCC4',
  B2: '#0A082F',
  B3: '#9F9FFF',
  B4: '#F0F0F3',
  B5: '#F7F7F9',
  B6: '#FBFBFC',
  AA4: '#D4BFFF',
  AA5: '#EADFFF',
  AB4: '#BFD4FF',
  AB5: '#DFEAFF',
};

/**
 * Définitions figées, injectées telles quelles, jamais générées par le LLM, qui ne fait que référencer ces noms via `class:` sur les shapes.
 */
const D2DIAGRAM_CLASS_DEFINITIONS = `classes: {
  green: {
    style: {
      fill: "#D7F2D3"
      stroke: "#65C167"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  purple: {
    style: {
      fill: "#E7DBFB"
      stroke: "#A374F2"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  yellow: {
    style: {
      fill: "#FCE7AC"
      stroke: "#E6B54A"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  blue: {
    style: {
      fill: "#C3E3F7"
      stroke: "#5AA9DC"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  orange: {
    style: {
      fill: "#FCE4D6"
      stroke: "#F4A261"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  red: {
    style: {
      fill: "#FADBD8"
      stroke: "#E74C3C"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  pink: {
    style: {
      fill: "#FCE4EC"
      stroke: "#F06292"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  brown: {
    style: {
      fill: "#EFEBE9"
      stroke: "#8D6E63"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  black: {
    style: {
      fill: "#E5E7EB"
      stroke: "#111827"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  gray: {
    style: {
      fill: "#F3F4F6"
      stroke: "#9CA3AF"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  white: {
    style: {
      fill: "#FFFFFF"
      stroke: "#D1D5DB"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  teal: {
    style: {
      fill: "#E0F2F1"
      stroke: "#4DB6AC"
      stroke-width: 2
      font-color: "#0A082F"
    }
  }
  connection: {
    style: {
      stroke: "#B9BCC4"
      stroke-width: 2
    }
  }
  connection_dashed: {
    style: {
      stroke: "#B9BCC4"
      stroke-width: 2
      stroke-dash: 4
    }
  }
  connection_green: {
    style: {
      stroke: "#65C167"
      stroke-width: 2
      font-color: "#2E6F31"
    }
  }
  connection_dashed_green: {
    style: {
      stroke: "#65C167"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#2E6F31"
    }
  }
  connection_purple: {
    style: {
      stroke: "#A374F2"
      stroke-width: 2
      font-color: "#5B2A9B"
    }
  }
  connection_dashed_purple: {
    style: {
      stroke: "#A374F2"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#5B2A9B"
    }
  }
  connection_yellow: {
    style: {
      stroke: "#E6B54A"
      stroke-width: 2
      font-color: "#966D12"
    }
  }
  connection_dashed_yellow: {
    style: {
      stroke: "#E6B54A"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#966D12"
    }
  }
  connection_blue: {
    style: {
      stroke: "#5AA9DC"
      stroke-width: 2
      font-color: "#256691"
    }
  }
  connection_dashed_blue: {
    style: {
      stroke: "#5AA9DC"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#256691"
    }
  }
  connection_orange: {
    style: {
      stroke: "#F4A261"
      stroke-width: 2
      font-color: "#A95512"
    }
  }
  connection_dashed_orange: {
    style: {
      stroke: "#F4A261"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#A95512"
    }
  }
  connection_red: {
    style: {
      stroke: "#E74C3C"
      stroke-width: 2
      font-color: "#922B21"
    }
  }
  connection_dashed_red: {
    style: {
      stroke: "#E74C3C"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#922B21"
    }
  }
  connection_pink: {
    style: {
      stroke: "#F06292"
      stroke-width: 2
      font-color: "#A62451"
    }
  }
  connection_dashed_pink: {
    style: {
      stroke: "#F06292"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#A62451"
    }
  }
  connection_brown: {
    style: {
      stroke: "#8D6E63"
      stroke-width: 2
      font-color: "#4A352E"
    }
  }
  connection_dashed_brown: {
    style: {
      stroke: "#8D6E63"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#4A352E"
    }
  }
  connection_black: {
    style: {
      stroke: "#111827"
      stroke-width: 2
      font-color: "#000000"
    }
  }
  connection_dashed_black: {
    style: {
      stroke: "#111827"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#000000"
    }
  }
  connection_gray: {
    style: {
      stroke: "#9CA3AF"
      stroke-width: 2
      font-color: "#374151"
    }
  }
  connection_dashed_gray: {
    style: {
      stroke: "#9CA3AF"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#374151"
    }
  }
  connection_white: {
    style: {
      stroke: "#D1D5DB"
      stroke-width: 2
      font-color: "#4B5563"
    }
  }
  connection_dashed_white: {
    style: {
      stroke: "#D1D5DB"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#4B5563"
    }
  }
  connection_teal: {
    style: {
      stroke: "#4DB6AC"
      stroke-width: 2
      font-color: "#226E67"
    }
  }
  connection_dashed_teal: {
    style: {
      stroke: "#4DB6AC"
      stroke-width: 2
      stroke-dash: 4
      font-color: "#226E67"
    }
  }
}`;


/**
 * Fusionne theme-overrides + classes + border-radius global en un seul bloc vars.d2-config avant d'être préfixé au code d2 reçu du LLM
 * @param d2Code
 * @param themeOverrides
 */
export const injectD2DiagramThemeAndClasses = (d2Code: string, themeOverrides: Record<string, string> = D2DIAGRAM_DEFAULT_THEME_OVERRIDES): string => {

  const overrideLines = Object.entries(themeOverrides)
      .map(([slot, color]) => `      ${slot}: "${color}"`)
      .join('\n');

  const varsBlock = `vars: {
  d2-config: {
    theme-overrides: {
${overrideLines}
    }
  }
}

***.style.border-radius: 10

${D2DIAGRAM_CLASS_DEFINITIONS}

`;

  return varsBlock + d2Code;
};

/**
 * On extrait tous les labels du d2. ils seront injectés sous forme de commentaires à la fin du code d2
 * en vue de l'indexation du diagramme.
 * @param compiledDiagram
 */
export const buildD2DiagramLabelsComment = (compiledDiagram: any): string | null => {
  if (!compiledDiagram) {
    return null;
  }

  const rawLabels = (compiledDiagram.shapes ?? [])
      .map((shape: any) => shape.label)
      .filter((label: string) => label && label.trim().length > 0);

  const rawConnections = (compiledDiagram.connections ?? [])
      .map((conn: any) => conn.label)
      .filter((label: string) => label && label.trim().length > 0);

  const labels = Array.from(new Set(rawLabels));
  const connections = Array.from(new Set(rawConnections));

  const json = JSON.stringify({labels, connections}, null, 2);
  return `\n"""${json}"""`;
}
